import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Icon } from 'antd';
import { connect } from 'react-redux';
const styles = {
  modalClass: {
    '& .ant-modal-body': {
      padding: '24px 0px 0px 0px',
      borderRadius: '5px',
    },
  },
  rowClass : {
    marginBottom: '15px',
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'space-around',
  },
};
class CreateInquiryProtip extends React.PureComponent<any, any> {
  render() {
    const { classes, handleClose, bookingId, handleNotifyUsers } = this.props;
    return <Modal
      closable={true}
      className={classes.modalClass}
      width={350}
      onCancel={handleClose}
      visible={this.props.visible}
      footer={null}>
      <div style={{
        height: 250, display: 'flex', flexDirection: 'column',
        alignContent: 'space-between', padding: '0px 24px 24px 24px',
      }}>
        <div className={classes.rowClass}>
          <Icon type="check-circle" theme="filled"
            style={{ color: '#52C41A', fontSize: '50px' }} />
        </div>
        <div className={classes.rowClass}>
          <h2>Success</h2>
        </div>
        <div className={classes.rowClass}>
          Your booking request has been initiated with booking ID {bookingId}
        </div>
        <div className={classes.rowClass}>
          <i style={{ fontSize: '11px' }}>
          {this.props.showBookingRequestedAdditionalEmails ?
            'Now you can send these updates via email to user(s)' :
            'Now you are being redirected to Bookings'
          }
          </i>
        </div>
        <div className={classes.rowClass} style={{ fontSize : '17px' }}>
          {this.props.showBookingRequestedAdditionalEmails ?
            <a onClick={handleNotifyUsers}>Notify Users</a> :
            <a onClick={handleClose}>Okay</a>
          }
        </div>
      </div>
    </Modal>;
  }
}

const mapStateToProps = ({ masterData }, ownProps) => ({
  showBookingRequestedAdditionalEmails: masterData?.modules?.show_booking_requested_additional_emails,
});

export default connect(mapStateToProps, null)(injectSheet(styles)(CreateInquiryProtip));
